import React from "react";
import { useTranslation } from "react-i18next";

const BadgeActiveButtons = ({ path, showShare, trackDownload }) => {
  const { t } = useTranslation();

  return (
    <>
      <a
        onClick={trackDownload}
        href={path}
        download={`Kickoff-Badge`}
        className="block text-center w-full mt-3 text-lg rounded-lg rounded-tr-none px-6 bg-w-2 text-white hover:text-white uppercase"
      >
        {t("download")}
      </a>
      <button
        className="w-full mt-3 text-lg rounded-lg rounded-tr-none px-6 bg-w-2 text-white uppercase"
        onClick={showShare}
      >
        {t("share")}
      </button>
    </>
  );
};

export default BadgeActiveButtons;
